
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


export default {
components: {XHeader, XInput, Group, XButton, Cell, XTextarea, Confirm, Selector, Previewer},
directives: {
TransferDom
},
data() {
return {
options: {
getThumbBoundsFn(index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}


}
},
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
},
orderDetail: {},
isHide: false,
iden: '',
address: '',
isCancel: false,
resultshow: false,
fastshow: false,
fast_advice: '',
solutionv: 1,
reason: [{key: 'ACCEPT', value: '接受'}, {key: 'REJECT', value: '拒绝'}],
confirm: 'ACCEPT',
advice: '',
list: [],
isAssis: false,
role: this.$route.query.role,
closed: false,
filename:'',
filepath:'',
}
},
methods: {
userevaluation() {
this.$router.push({name: 'userevaluation', params: {obj: this.orderDetail}})
},

downloadFile(){
this.$router.push({
name: "Download",
query: {path:this.filepath, suffix:this.filename}
});
},

bxjl() {
this.$router.push({name: 'makeMemo', params: {iden: 'EXPT', solutionv: this.solutionv}})
},
show(index) {
this.$refs.previewer.show(index)
},
cancel() {
this.$router.push({name: 'cancelCause', params: {obj: this.orderDetail}})
},
addphoto() {
this.$router.push({name: 'addphoto', params: {isAssis: !this.isAssis}})
},
cancelResult(seq) {
const that = this
if (this.orderDetail.userconfirm === '待处理') {
if (this.confirm === 'REJECT') {
this.$vux.confirm.show({
content: '如再次拒绝，将会进入仲裁流程',
theme: 'android',
onCancel() {

},
onConfirm() {
that.close(seq)
}
})
} else {
this.close(seq)
}
} else {
this.close(seq)
}
},
fastResult(seq) {
this.$http.get('/api/v1/normalrepairs/' + seq + '/urge?role=EXPT&type=detail&advice=' + this.fast_advice, this.header)
.then(() => {
this.fastshow = false;
alert('催单成功');
this.$router.back()
})
.catch((err) => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
});
},
close(seq) {
this.$http.put('/api/normalrepairs/' + seq + '/user_confirm', {
role: 'INDV',
confirm: this.confirm,
advice: this.advice
}, this.header).then(response => {
this.resultshow = false;
this.$router.push({name: 'normalrepairslist'})
}).catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
}
},
beforeRouteEnter: function (to, from, next) {
if (to.query.role) {
next(vm => {
vm.isAssis = true
AjaxPlugin.$http.get('/api/v1/normalrepairs/' + to.query.seq + '?role=EXPT&type=detail', vm.header).then(response => {
localStorage.setItem('order', JSON.stringify(response.data.detail))
vm.orderDetail = response.data.detail
vm.isCancel = vm.orderDetail.userconfirm === 'WAIT1' || vm.orderDetail.userconfirm === 'WAIT2';
vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district
if (vm.orderDetail.confirm === "WAIT") {
vm.isHide = true
}
if (vm.orderDetail.canstate === 'REQUEST') {
vm.isHide = false
}
vm.orderDetail.isviwo = vm.orderDetail.isviwo ? '是' : '否';
vm.orderDetail.sevenday = vm.orderDetail.sevenday ? '是' : '否';
vm.solutionv = vm.orderDetail.solutionv
switch (vm.orderDetail.userconfirm) {
case "ACCEPT":
vm.orderDetail.userconfirm = '接受'
break
case "REJECT":
vm.orderDetail.userconfirm = '拒绝'
break
case "ARBIT":
vm.orderDetail.userconfirm = '仲裁'
break
case 'WAIT1':
vm.orderDetail.userconfirm = '等待处理'
break
case 'WAIT2':
vm.orderDetail.userconfirm = '待处理'
break
case 'A_ACCEPT':
vm.orderDetail.userconfirm = '自动确认'
break
default:
vm.orderDetail.userconfirm = '等待处理'
break
}
vm.list = [];
console.log(vm.orderDetail.signature)
if (vm.orderDetail.signature && vm.orderDetail.signature.content.length !== 0) {
if(vm.orderDetail.signature.content[0].describe==""){
vm.orderDetail.signature.content[0].path.forEach(item => {
let path = vm.orderDetail.signature.version === '1.0' ? item : item['origin']
AjaxPlugin.$http.get('/api/photos?path=' + path, header).then(paths => {
vm.list.push({src: 'data:image/jpeg;base64,' + paths.data['value']});
});
});
}else{

vm.filename = vm.orderDetail.signature.content[0].describe
vm.filepath = vm.orderDetail.signature.content[0].path[0].origin
}

}


})
})
} else {
next(vm => {
const openid = localStorage.getItem('openid')
const unionid = localStorage.getItem('unionid')
let account
AjaxPlugin.$http.get('api/v1/wechat/' + unionid).then((res) => {



res.data.forEach(item => {
if (item.role === 'INDV') {
account = item.account
}
})
AjaxPlugin.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account}).then(response => {
localStorage.setItem('token', response.data.token)
localStorage.setItem('userid', response.data.userid)
vm.header = {
headers: {
token: response.data.token,
opid: response.data.userid
}
}
AjaxPlugin.$http.get('/api/v1/normalrepairs/' + to.query.seq + '?role=INDV&type=detail', vm.header).then(response => {
localStorage.setItem('order', JSON.stringify(response.data.detail))
vm.closed = response.data.closed
vm.orderDetail = response.data.detail
vm.isCancel = vm.orderDetail.userconfirm === 'WAIT1' || vm.orderDetail.userconfirm === 'WAIT2';
vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district
if (vm.orderDetail.confirm === "WAIT") {
vm.isHide = true
}
if (vm.orderDetail.canstate === 'REQUEST') {
vm.isHide = false
}
vm.orderDetail.isviwo = vm.orderDetail.isviwo ? '是' : '否';
vm.orderDetail.sevenday = vm.orderDetail.sevenday ? '是' : '否';
switch (vm.orderDetail.userconfirm) {
case "ACCEPT":
vm.orderDetail.userconfirm = '接受'
break
case "REJECT":
vm.orderDetail.userconfirm = '拒绝'
break
case "ARBIT":
vm.orderDetail.userconfirm = '仲裁'
break
case 'WAIT1':
vm.orderDetail.userconfirm = '等待处理'
break
case 'WAIT2':
vm.orderDetail.userconfirm = '待处理'
break
case 'A_ACCEPT':
vm.orderDetail.userconfirm = '自动确认'
break
default:
vm.orderDetail.userconfirm = '等待处理'
break
}
vm.list = [];
if (vm.orderDetail.signature && vm.orderDetail.signature.content.length !== 0) {
if(vm.orderDetail.signature.content[0].describe==""){
vm.orderDetail.signature.content[0].path.forEach(item => {
let path = vm.orderDetail.signature.version === '1.0' ? item : item['origin']
AjaxPlugin.$http.get('/api/photos?path=' + path, header).then(paths => {
vm.list.push({src: 'data:image/jpeg;base64,' + paths.data['value']});
});
});
}else{

vm.filename = vm.orderDetail.signature.content[0].describe
vm.filepath = vm.orderDetail.signature.content[0].path[0].origin
}

}
})
})
})
})
}
}

}



// WEBPACK FOOTER //
// ./src/components/normalcomplete.vue